import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowGreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 500 800",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: url(#Degradado_sin_nombre_3);\n      }\n    " }), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "Degradado_sin_nombre_3",
		"data-name": "Degradado sin nombre 3",
		x1: 18.26,
		y1: 402,
		x2: 481.74,
		y2: 402,
		gradientTransform: "translate(0 802) scale(1 -1)",
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: 0,
			stopColor: "#00ac5e"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: .61,
			stopColor: "#00e977"
		})]
	})] }), /* @__PURE__ */ _jsx("polygon", {
		className: "st0",
		points: "99.14 16.96 481.74 399.27 481.16 399.85 481.74 400.43 99.14 783.04 18.26 701.86 320.27 399.85 18.26 97.84 99.14 16.96"
	})]
});
export default SvgArrowGreen;
